import * as React from "react";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  /** Spacing between dots in px. */
  size?: number;
  /** Dot diameter in px. */
  dot?: number;
  /** Fade falloff: "radial" = fades to centre, "edges" = fades to corners. */
  fade?: "radial" | "edges" | "none";
};

/**
 * Aceternity-style dot grid background. Pure SVG (no JS), tiled via
 * pattern. Render INSIDE a `relative` parent.
 */
export function GridPattern({
  className,
  size = 28,
  dot = 1.2,
  fade = "radial"
}: Props) {
  const id = React.useId();
  const maskGradient = fade === "radial"
    ? "radial-gradient(ellipse at center, white 0%, transparent 75%)"
    : fade === "edges"
    ? "radial-gradient(ellipse at center, transparent 30%, white 95%)"
    : undefined;

  return (
    <div
      aria-hidden
      className={cn("absolute inset-0 pointer-events-none", className)}
      style={maskGradient
        ? { WebkitMaskImage: maskGradient, maskImage: maskGradient }
        : undefined}
    >
      <svg width="100%" height="100%" className="absolute inset-0">
        <defs>
          <pattern id={`grid-${id}`} width={size} height={size} patternUnits="userSpaceOnUse">
            <circle cx={size / 2} cy={size / 2} r={dot} fill="rgba(255,255,255,0.10)" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#grid-${id})`} />
      </svg>
    </div>
  );
}
